// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    hmr       : false,
    stationId : 'VR_STATION_1',
    firebaseConfig: { 
        apiKey: "AIzaSyA0sUP-iRUYpjjAJnlb5bpNOIekd7VK2EM",
        authDomain: "marion-surgical-dev.firebaseapp.com",
        databaseURL: "https://marion-surgical-dev.firebaseio.com",
        projectId: "marion-surgical-dev",
        storageBucket: "marion-surgical-dev.appspot.com",
        messagingSenderId: "900906098907"
    } 
};



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/environments/environment.ts